module.exports = new __parcel__URL__("space_elixir_accelerator_level_1.6d66a55b.png").toString();